module.exports = "/_next/static/images/download-app-large-6e7893012539f14453aead260ddad527.png";